<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" href="/volunteers">{{$t('volunteers.volunteers')}}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ form.first_name }} {{ form.last_name }}
    </h1>
    <trashed-message v-if="data.deleted_at && !viaVolunteer" class="mb-6" @restore="restore"> {{$t('volunteers.trashed_message')}}</trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <Form :form-data="form" :languages="languages" :via-volunteer="viaVolunteer"></Form>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!data.deleted_at && !viaVolunteer" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{$t('global.delete')}}</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{$t('global.update')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    data: Object,
    languages: Array,
    viaVolunteer: {
      type: Boolean,
      default: false
    },
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: this.data.first_name,
        last_name: this.data.last_name,
        date_birth: this.data.date_birth,
        date_entry: this.data.date_entry,
        date_exit: this.data.date_exit,
        career: this.data.career,
        hobbies: this.data.hobbies,
        phone: this.data.phone,
        email: this.data.email,
        street: this.data.street,
        street_number: this.data.street_number,
        zip_code: this.data.zip_code,
        city: this.data.city,
        authorization_date: this.data.authorization_date,
        visitor: !!this.data.visitor,
        max_treatments: this.data.max_treatments.toString(),
        status: !!this.data.status,
        language_ids: this.data.language_ids,
        language_field: this.data.language_field,
      }),
    }
  },
  methods: {
    update() {
      if (this.viaVolunteer) {
        // Beveiliging wanneer ze disabled zouden weghalen op het input field
        this.form.status = this.data.status
        this.form.put(`/volunteer`)
      } else {
        this.form.put(`/volunteers/${this.data.id}`)
      }

    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/volunteers/${this.data.id}`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/volunteers/${this.data.id}/restore`)
        }
      })
    },
  },
}
</script>
